import AssetsManager from '../../common/data/AssetsManager'
import DataManager from '../../common/data/DataManager'

/**
 * CommonModalViewクラス
 */
class CommonModalView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	CommonModalView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //zIndex
    this.zIndex = 200

    //PIXI.Application参照
    this.app = DataManager.getData('app')

    //背景色
    this.bg = new PIXI.Graphics()
    this.bg.beginFill(0x000000)
    this.bg.drawRect(0, 0, 100, 100)
    this.bg.endFill()
    this.bg.alpha = 0.4
    this.bg.interactive = true
    this.addChild(this.bg)

    //コンテナ
    this.panelContainer = new PIXI.Container()
    this.addChild(this.panelContainer)

    //パネル
    const panel = new PIXI.Graphics()
    panel.beginFill(0xFFFFFF)
    panel.drawRoundedRect(-632, -342, 1264, 684, 28)
    panel.endFill()
    this.panelContainer.addChild(panel)

    //しまジロー
    this.shimajiro1 = AssetsManager.createSpriteByName('common_modal_shimajiro_reload.png')
    this.shimajiro1.anchor.set(0.5, 0.5)
    this.shimajiro1.x = 1.3
    this.shimajiro1.y = -159
    this.panelContainer.addChild(this.shimajiro1)

    this.shimajiro2 = AssetsManager.createSpriteByName('common_modal_shimajiro_quit.png')
    this.shimajiro2.anchor.set(0.5, 0.5)
    this.shimajiro2.x = -1.5
    this.shimajiro2.y = -146
    this.panelContainer.addChild(this.shimajiro2)

    //テキスト
    this.txt = AssetsManager.createMovieClip(['common_modal_txt1.png', 'common_modal_txt2.png', 'common_modal_txt3.png'])
    this.txt.anchor.set(0.5, 1.0)
    this.txt.x = 0
    this.txt.y = 108
    this.txt.gotoAndStop(0)
    this.panelContainer.addChild(this.txt)

    //リロードボタン
    this.reloadBtn = AssetsManager.createSpriteByName('common_modal_reload_btn.png')
    this.reloadBtn.anchor.set(0.5, 0.5)
    this.reloadBtn.x = 0
    this.reloadBtn.y = 230
    this.panelContainer.addChild(this.reloadBtn)
    this.reloadBtn.buttonMode = true
    this.reloadBtn.interactive = true
    this.reloadBtn.on('tap', this.onReload.bind(this))
    this.reloadBtn.on('click', this.onReload.bind(this))

    //やめるボタン
    this.quitBtn = AssetsManager.createSpriteByName('common_modal_quit_btn.png')
    this.quitBtn.anchor.set(0.5, 0.5)
    this.quitBtn.x = -235
    this.quitBtn.y = 230
    this.panelContainer.addChild(this.quitBtn)
    this.quitBtn.buttonMode = true
    this.quitBtn.interactive = true
    this.quitBtn.on('tap', this.onQuit.bind(this))
    this.quitBtn.on('click', this.onQuit.bind(this))

    //つづけるボタン
    this.continueBtn = AssetsManager.createSpriteByName('common_modal_continue_btn.png')
    this.continueBtn.anchor.set(0.5, 0.5)
    this.continueBtn.x = 235
    this.continueBtn.y = 230
    this.panelContainer.addChild(this.continueBtn)
    this.continueBtn.buttonMode = true
    this.continueBtn.interactive = true
    this.continueBtn.on('tap', this.onContinue.bind(this))
    this.continueBtn.on('click', this.onContinue.bind(this))

    //リセット
    this.reset()
  }

  /**
   * リセット
   */
  reset()
  {
    //背景非表示
    this.bg.alpha = 0

    //パネル初期表示
    this.panelContainer.alpha = 0
    this.panelContainer.scale.set(0.8, 0.8)

    //ボタン押せなく
    this.reloadBtn.interactive = false
    this.quitBtn.interactive = false
    this.continueBtn.interactive = false

    //ボタン非表示
    this.reloadBtn.visible = false
    this.quitBtn.visible = false
    this.continueBtn.visible = false

    //全体非表示
    this.alpha = 1
    this.visible = false

    //サウンドロック解除
    AssetsManager.soundLock(false)
  }

  /**
   * 表示
   */
  show(type)
  {
    //一度リセット
    this.reset()

    //SOUNDを全て停止
    AssetsManager.stopAllSounds()

    //イベント発行
    this.app.emitter.emit('OPEN_COMMON_MODAL')

    //タイプごとに表示内容をかえる
    let soundID = ''
    switch(type){
      case 'close':
        this.txt.gotoAndStop(0)
        this.quitBtn.visible = true
        this.continueBtn.visible = true
        this.shimajiro1.visible = false
        this.shimajiro2.visible = true
        soundID = 'sound_quit'
        break
      case 'furikaeri_close':
        this.txt.gotoAndStop(2)
        this.quitBtn.visible = true
        this.continueBtn.visible = true
        this.shimajiro1.visible = false
        this.shimajiro2.visible = true
        soundID = 'sound_furikaeri_quit'
        break
      case 'reload':
        this.txt.gotoAndStop(1)
        this.reloadBtn.visible = true
        this.shimajiro1.visible = true
        this.shimajiro2.visible = false
        soundID = 'sound_reload'
        break
    }

    //表示
    this.visible = true

    //アクティブフラグ
    this.isActive = true

    //黒フェード
    gsap.to(this.bg, 0.1, {
      alpha :0.4,
      ease  :'none'
    })

    //パネルフェードイン
    gsap.to(this.panelContainer, 0.4, {
      alpha :1,
      delay :0.1,
      ease  :'none'
    })
    gsap.to(this.panelContainer.scale, 0.6, {
      x     :1,
      y     :1,
      delay :0.1,
      ease  :'back.out(1.7)',
      onComplete:()=>{
        this.reloadBtn.interactive = true
        this.quitBtn.interactive = true
        this.continueBtn.interactive = true
        AssetsManager.playSound('common', soundID)
        AssetsManager.soundLock(true)
      }
    })

    //リサイズ
    this.resize();
  }

  /**
   * 閉じる
   */
  close()
  {
    //イベント発行
    this.app.emitter.emit('CLOSE_COMMON_MODAL')

    //フェードアウト
    gsap.to(this, 0.2, {
      alpha     :0,
      ease      :'none',
      onComplete:()=>{
        this.reset()
        this.emit('closed')
      }
    })
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	入力
  // ---------------------------------------------------------------------------------------------------------

  onReload()
  {
    //SOUNDを全て停止
    AssetsManager.stopAllSounds()

    //ボタン押せなくする
    this.reloadBtn.interactive = false

    //画面リロード
    location.reload()
  }

  onQuit()
  {
    //SOUNDを全て停止
    AssetsManager.stopAllSounds()

    //ボタン押せなくする
    this.quitBtn.interactive = false
    this.continueBtn.interactive = false

    //イベント発行
    this.emit('QUIT')
  }

  onContinue()
  {
    //SOUNDを全て停止
    AssetsManager.stopAllSounds()

    //ボタン押せなくする
    this.quitBtn.interactive = false
    this.continueBtn.interactive = false

    //閉じる
    this.close()
  }


  // ---------------------------------------------------------------------------------------------------------
  // --	リサイズ
  // ---------------------------------------------------------------------------------------------------------

  resize()
  {
    this.bg.width = this.app.renderer.width
    this.bg.height = this.app.renderer.height

    this.panelContainer.x = this.app.renderer.width/2
    this.panelContainer.y = this.app.renderer.height/2
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default CommonModalView
